import type { ComponentType } from 'react'
import {
  Activity,
  Cake,
  ClipboardList,
  Gift,
  House,
  Settings,
  Store,
  Users,
} from 'lucide-react-native'
import type { LucideProps } from 'lucide-react-native'

export type AdminSectionRouteName =
  | 'AdminHome'
  | 'AdminMembers'
  | 'AdminRecentActivity'
  | 'AdminAuditLog'
  | 'AdminLoyalty'
  | 'AdminBirthdayReward'
  | 'AdminCashiersDevices'
  | 'AdminSettings'

export type AdminSectionParams = {
  AdminHome: undefined
  AdminMembers: undefined
  AdminRecentActivity: { initialMemberQuery?: string } | undefined
  AdminAuditLog: undefined
  AdminLoyalty: undefined
  AdminBirthdayReward: undefined
  AdminCashiersDevices: undefined
  AdminSettings: undefined
}

export interface AdminSectionRoute {
  name: AdminSectionRouteName
  navLabelKey: string
  titleKey: string
  subtitleKey: string
  Icon: ComponentType<LucideProps>
}

export const ADMIN_SECTION_ROUTES: AdminSectionRoute[] = [
  {
    name: 'AdminHome',
    navLabelKey: 'nav.home',
    titleKey: 'adminDashboard.homeTitle',
    subtitleKey: 'adminDashboard.homeSubtitle',
    Icon: House,
  },
  {
    name: 'AdminMembers',
    navLabelKey: 'nav.members',
    titleKey: 'adminDashboard.membersTitle',
    subtitleKey: 'adminDashboard.membersSubtitle',
    Icon: Users,
  },
  {
    name: 'AdminLoyalty',
    navLabelKey: 'nav.loyalty',
    titleKey: 'adminDashboard.loyaltyTitle',
    subtitleKey: 'adminDashboard.loyaltySubtitle',
    Icon: Gift,
  },
  {
    name: 'AdminBirthdayReward',
    navLabelKey: 'nav.birthdayReward',
    titleKey: 'adminDashboard.birthdayRewardTitle',
    subtitleKey: 'adminDashboard.birthdayRewardSubtitle',
    Icon: Cake,
  },
  {
    name: 'AdminCashiersDevices',
    navLabelKey: 'nav.operations',
    titleKey: 'adminDashboard.operationsTitle',
    subtitleKey: 'adminDashboard.operationsSubtitle',
    Icon: Store,
  },
  {
    name: 'AdminRecentActivity',
    navLabelKey: 'nav.recentActivity',
    titleKey: 'adminDashboard.recentActivityTitle',
    subtitleKey: 'adminDashboard.recentActivitySubtitle',
    Icon: Activity,
  },
  {
    name: 'AdminAuditLog',
    navLabelKey: 'nav.auditLog',
    titleKey: 'adminDashboard.auditLogTitle',
    subtitleKey: 'adminDashboard.auditLogSubtitle',
    Icon: ClipboardList,
  },
  {
    name: 'AdminSettings',
    navLabelKey: 'nav.settings',
    titleKey: 'adminDashboard.settingsTitle',
    subtitleKey: 'adminDashboard.settingsSubtitle',
    Icon: Settings,
  },
]

export const ADMIN_SECTION_ROUTE_BY_NAME = ADMIN_SECTION_ROUTES.reduce<
  Record<AdminSectionRouteName, AdminSectionRoute>
>((routesByName, route) => {
  routesByName[route.name] = route
  return routesByName
}, {} as Record<AdminSectionRouteName, AdminSectionRoute>)
